export { Phone } from './phone';
export { PhoneList } from './phone-list';
export { Brand } from './brand';
export { Variant } from './variant';



// WEBPACK FOOTER //
// ./src/app/fonzi-module/models/index.ts